import axios from 'axios'

const API_PATH = 'api/v2/admins/products/dimensions'

const ProductDimensionsApiV2 = {

  /**
   * Update Product Dimension attribute (only update `Product::Dimension.measurement` model)
   * @param {number} id - Product id
   * @param {object} payload - Updated attributes
   */
  update: async ({ id, payload }) => {
    const path = `${API_PATH}/${id}`

    const { product_size_id, ...measurements } = payload
    const body                                 = {
      product_dimension: {
        product_size_id : product_size_id,
        measurements    : measurements
      }
    }

    const response = axios.patch(path, body)
    return response
  }
}

export default ProductDimensionsApiV2
